module.exports = __webpack_public_path__ + "img/intro2_en.01e44568.jpg";